import React from 'react';

import { Box, Skeleton } from '@mui/material';

export const OnboardingItemsSkeleton = () => {
  const skeletonMap = Array(6).fill('');

  const renderSkeleton = skeletonMap.map((_, index) => (
    <Box key={index} display={'flex'} alignItems={'center'}>
      <Skeleton sx={{ height: '20px', width: '20px', mr: '8px' }} variant="circular" />
      <Skeleton sx={{ height: '20px', width: '50%', borderRadius: '8px' }} variant="rectangular" />
    </Box>
  ));
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>{renderSkeleton}</Box>
  );
};
